<template>
  <span>
    <span class="tree_node_label">{{ label }}</span>
    <BaseValidRadio
        v-validate="data.validateRule"
        :class="data.class"
        :name="name"
        :value="value"
        :radio-list="options"
        :disabled="disabled"
        :error-msg="errorMessage"
        button
        @input="onChange" />
  </span>
</template>

<style scoped>
.tree_node_label {
  margin-right: 20px;
}
</style>

<script>
import x from '@/components/mixins/mixin'
import BaseValidRadio from '@/components/atoms/BaseValidRadio'

export default {
  name: 'BaseTreeNodeRadio',
  components: {
    BaseValidRadio
  },
  mixins: [x],
  inject: ['parentValidator'],
  props: {
    label: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => { return {} }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    displayItem: {
      type: Object,
      default: () => { return {} }
    },
    selectCode: {
      type: [String, Function],
      default: ''
    },
    siteCode: {
      type: String,
      default: null
    },
    validateScope: {
      type: String,
      default: null
    }
  },
  computed: {
    name () {
      return this.data.path
    },
    value () {
      return this.$_mixin_getData(this.displayItem, this.data.path)
    },
    options () {
      return typeof this.selectCode === 'function'
        ? this.selectCode(this)
        : this.$_mixin_selectOptions(this.selectCode, { siteCode: this.siteCode })
    },
    errorMessage () {
      return this.errors.first(this.name, this.validateScope)
    }
  },
  created () {
    this.$validator = this.parentValidator
  },
  methods: {
    async onChange (event) {
      this.$_mixin_updateValue(event, this.displayItem, this.data.path)
      if (typeof this.data.onChange === 'function') {
        await this.data.onChange(event, this.data.path)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/molecules/BaseTreeNodeRadio.vue